<template>
<div class="chapter">
<div class="inner_page">
<p class="default" id="d8e146NaN">
</p><p class="ctch" id="d7e903"><a href="#/Lodi_9781937084325_epub_toc_r1#d6e1" id="d7e1"><b>Part One </b></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Lodi_9781937084325_epub_c3_r1.vue?ee526de0